<template>
  <div class="modal-overlay" v-if="isOpen">
    <div class="modal-item">
      <h3 class="text-center mb30">Konfigurasi</h3>
      <form>
        <label style="margin: 0 0 0 6rem; font-size: small; color: gray;">Keterangan: 1 Hari = 9 Jam</label>
        <div class="form-row">
          <div class="input-group">
            <label for="SIPM" class="text-bold">Target SIPM:</label>
            <label for="startSIPMhour">Jam:</label>
            <input type="number" id="startSIPMhour" @input="handleTimeChange" v-model="startSIPMHour" min="0"
              class="input-conf" />
            <label for="startSIPMminute">Menit:</label>
            <input type="number" id="startSIPMminute" @input="handleTimeChange" v-model="startSIPMMinute" min="0"
              max="60" class="input-conf" />
            <!-- </div> -->
            <label class="text-center text-bold">s/d</label>
            <!-- <div class="form-row"> -->

            <label for="endSIPMhour">Jam:</label>
            <input type="number" id="endSIPMhour" @input="handleTimeChange" v-model="endSIPMHour" min="0"
              class="input-conf" />
            <label for="endSIPMminute">Menit:</label>
            <input type="number" id="endSIPMminute" @input="handleTimeChange" v-model="endSIPMMinute" min="0" max="60"
              class="input-conf" />
          </div>
        </div>
        <div class="form-row">
          <div class="input-group">
            <label for="Penilai" class="text-bold">Target Ops.Comp:</label>
            <label for="startL5hour">Jam:</label>
            <input type="number" id="startL5hour" @input="handleTimeChange" v-model="startPenilaiHour" min="0"
              class="input-conf" />
            <label for="startL5minute">Menit:</label>
            <input type="number" id="startL5minute" @input="handleTimeChange" v-model="startPenilaiMinute" min="0"
              max="60" class="input-conf" />
            <!-- </div> -->
            <label class="text-center text-bold">s/d</label>
            <!-- <div class="form-row"> -->

            <label for="endL5hour">Jam:</label>
            <input type="number" id="endL5hour" @input="handleTimeChange" v-model="endPenilaiHour" min="0"
              class="input-conf" />
            <label for="endL5minute">Menit:</label>
            <input type="number" id="endL5minute" @input="handleTimeChange" v-model="endPenilaiMinute" min="0" max="60"
              class="input-conf" />
          </div>
        </div>
        <div style="margin: 0 auto;">
          <button @click="closeModal" style="padding: .2rem 1rem;">OK</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { api } from '@/services/config'
export default {
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      startSIPMHour: 0,
      startSIPMMinute: 0,
      endSIPMHour: 0,
      endSIPMMinute: 0,

      startPenilaiHour: 0,
      startPenilaiMinute: 0,
      endPenilaiHour: 0,
      endPenilaiMinute: 0,
    }
  },
  created() {
    this.setConfig()
  },
  methods: {
    handleTimeChange() {
      if (this.startSIPMMinute >= 60) {
        const additionalHours = Math.floor(this.startSIPMMinute / 60)
        this.startSIPMHour += additionalHours
        this.startSIPMMinute = this.startSIPMMinute % 60
      }
      if (this.endSIPMMinute >= 60) {
        const additionalHours = Math.floor(this.endSIPMMinute / 60)
        this.endSIPMHour += additionalHours
        this.endSIPMMinute = this.endSIPMMinute % 60
      }
      if (this.startPenilaiMinute >= 60) {
        const additionalHours = Math.floor(this.startPenilaiMinute / 60)
        this.startPenilaiHour += additionalHours
        this.startPenilaiMinute = this.startPenilaiMinute % 60
      }
      if (this.endPenilaiMinute >= 60) {
        const additionalHours = Math.floor(this.endPenilaiMinute / 60)
        this.endPenilaiHour += additionalHours
        this.endPenilaiMinute = this.endPenilaiMinute % 60
      }
    },
    async setConfig() {
      const { data } = await axios({
        method: 'get',
        url: `${api}/api/v1/m-kpi-config?type=4`,
      })

      if (data && data.status == 'success') {
        const getConfig = data.data

        this.startSIPMHour = Number(getConfig.filter(i => i.subname == 'Target SIPM')[0].firstValue)
        this.startSIPMMinute = Number(getConfig.filter(i => i.subname == 'Target SIPM')[0].secondValue)
        this.endSIPMHour = Number(getConfig.filter(i => i.subname == 'Target SIPM')[0].thirdValue)
        this.endSIPMMinute = Number(getConfig.filter(i => i.subname == 'Target SIPM')[0].fourthValue)

        this.startPenilaiHour = Number(getConfig.filter(i => i.subname == 'Target Ops.Comp')[0].firstValue)
        this.startPenilaiMinute = Number(getConfig.filter(i => i.subname == 'Target Ops.Comp')[0].secondValue)
        this.endPenilaiHour = Number(getConfig.filter(i => i.subname == 'Target Ops.Comp')[0].thirdValue)
        this.endPenilaiMinute = Number(getConfig.filter(i => i.subname == 'Target Ops.Comp')[0].fourthValue)

        this.$store.commit('kpiStore/UPDATE_DATA', {
          name: `for_k3l_value`,
          value: {
            sipm_id: Number(getConfig.filter(i => i.subname == 'Target SIPM')[0].id),
            startSIPMHour: Number(getConfig.filter(i => i.subname == 'Target SIPM')[0].firstValue),
            startSIPMMinute: Number(getConfig.filter(i => i.subname == 'Target SIPM')[0].secondValue),
            endSIPMHour: Number(getConfig.filter(i => i.subname == 'Target SIPM')[0].thirdValue),
            endSIPMMinute: Number(getConfig.filter(i => i.subname == 'Target SIPM')[0].fourthValue),

            penilai_id: Number(getConfig.filter(i => i.subname == 'Target Ops.Comp')[0].id),
            startPenilaiHour: Number(getConfig.filter(i => i.subname == 'Target Ops.Comp')[0].firstValue),
            startPenilaiMinute: Number(getConfig.filter(i => i.subname == 'Target Ops.Comp')[0].secondValue),
            endPenilaiHour: Number(getConfig.filter(i => i.subname == 'Target Ops.Comp')[0].thirdValue),
            endPenilaiMinute: Number(getConfig.filter(i => i.subname == 'Target Ops.Comp')[0].fourthValue),
          },
        })
      }
    },
    async closeModal() {
      const setConfig = {
        ...this.$store.state.kpiStore.for_k3l_value,
        startSIPMHour: this.startSIPMHour,
        startSIPMMinute: this.startSIPMMinute,
        endSIPMHour: this.endSIPMHour,
        endSIPMMinute: this.endSIPMMinute,

        startPenilaiHour: this.startPenilaiHour,
        startPenilaiMinute: this.startPenilaiMinute,
        endPenilaiHour: this.endPenilaiHour,
        endPenilaiMinute: this.endPenilaiMinute,
      }

      try {
        this.$store.commit('kpiStore/UPDATE_DATA', {
          name: `sla_loading`,
          value: true,
        })

        await axios({
          method: 'POST',
          url: `${api}/api/v1/m-kpi-config`,
          data: [
            {
              id: setConfig.sipm_id,
              firstValue: setConfig.startSIPMHour,
              secondValue: setConfig.startSIPMMinute,
              thirdValue: setConfig.endSIPMHour,
              fourthValue: setConfig.endSIPMMinute,
            },
            {
              id: setConfig.penilai_id,
              firstValue: setConfig.startPenilaiHour,
              secondValue: setConfig.startPenilaiMinute,
              thirdValue: setConfig.endPenilaiHour,
              fourthValue: setConfig.endPenilaiMinute,
            },

          ],
        })

        this.$store.commit('kpiStore/UPDATE_DATA', {
          name: `for_k3l_value`,
          value: setConfig,
        })

        this.$store.commit('kpiStore/UPDATE_DATA', {
          name: `sla_loading`,
          value: false,
        })
        this.$emit('close')
      } catch (error) {
        console.error(error)
        this.$store.commit('kpiStore/UPDATE_DATA', {
          name: `sla_loading`,
          value: false,
        })
      }


    },
  },
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-item {
  background-color: white;
  padding: 20px 0;
  border-radius: 5px;
  width: 60vw;
}

form {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  height: 40vh;
  width: 100%;
  /* margin: 0 auto; */
  /* overflow: auto; */
}

.form-row {
  display: flex;
  flex-direction: row;
  justify-content: center;
  /* gap: 10px; */
  width: 100%;
}

.input-group {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 10px;
  padding: 0 50px
    /* width: 80%; */
}

.form-column {
  display: flex;
  flex-direction: column;
  /* gap: 10px; */
}

.modal-item input {
  padding: 0.2rem;
  height: 30px;
  width: 60px;
}

.modal-item button {
  padding: 0.1rem 0.5rem;
  background-color: white;
  color: red;
  border: solid 1px red;
  border-radius: 5px;
  cursor: pointer;
  margin: 10px auto;
}

.modal-item button:hover {
  background-color: red;
  color: white;
  border: solid 1px white;
}
</style>
